import { createFileRoute } from '@tanstack/react-router'

import { OauthNewUser } from '@/pages/auth/route-entries/oauth-new-user'

export const Route = createFileRoute('/_auth/login/oauth/start')({
  component: OauthNewUser,
})
